import { type ScheduleChatMessageSendingJobInputTarget } from '@/types/schema.generated'
import * as v from 'valibot'
import { segmentSchema } from '@/features/segment/components/SegmentForm/formSchema'

const targetSchema = v.object({
  allUsers: v.optional(v.object({})),
  targetUsers: v.optional(
    v.object({
      okanentClientUserIds: v.pipe(v.array(v.string()), v.minLength(1)),
    })
  ),
  segmentUsers: v.optional(
    v.pipe(
      v.object({
        segment: segmentSchema,
      }),
      v.forward(
        v.check(({ segment }) => {
          const conditions = segment?.conditions
          if (conditions === undefined) {
            return false
          }
          if (conditions!.length === 0) {
            return false
          }
          return true
        }, '条件が設定されていません'),
        ['segment']
      )
    )
  ),
})

type validateTargetResponse =
  | { success: true; output: ScheduleChatMessageSendingJobInputTarget }
  | { success: false; errors: TargetFormErrors }
export type TargetFormErrors = v.FlatErrors<typeof targetSchema>
export type TargetFormErrorManager = {
  set: (errors: TargetFormErrors | undefined) => void
  getStartsWith: (path: string) => string | undefined
}
export const validateTarget = (
  target: unknown,
  setFormError: TargetFormErrorManager['set']
): validateTargetResponse => {
  const result = v.safeParse(targetSchema, target)

  if (result.success) {
    setFormError(undefined)
    return {
      success: true,
      output: result.output,
    }
  }

  const errors = v.flatten(result.issues)
  setFormError(errors)
  return {
    success: false,
    errors: errors,
  }
}
